import { render } from "./HasAllMaterial.vue?vue&type=template&id=3f76838f"
import script from "./HasAllMaterial.vue?vue&type=script&lang=js"
export * from "./HasAllMaterial.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__